import { createStore } from "redux";
import baseTravel from "reducers";

/* eslint-disable no-underscore-dangle */
const store = createStore(
  baseTravel /* preloadedState, */,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */

export default store;
